<template>
<div class="app-project-sources-splash page-main">
  <div class="page-main__content">

    <div class="app-project-sources-splash__section is--analyzing" v-if="isAnalyzing">
      <div class="app-project-sources-splash__section-content">
        <div class="app-project-sources-splash__section-column is--text">
          <h4 class="app-project-sources-splash__section-title page-main__section-title">Analyzing your documents...</h4>
          <p class="app-project-sources-splash__section-instructions">
            Now that document analysis has begun, you can no longer make any changes. Note that this process may take several hours. You and any other listed project members will receive an email notification when it is complete and you're all set for course creation.
            <br /><br />
            View your progress below or, if you would like to leave the application, log out.
          </p>
          <div class="element-progress">
            <div class="element-progress__text">{{ getProgressPercentage }}% completed</div>
            <div class="element-progress__bar">
              <div
                class="element-progress__bar-filled"
                role="progressbar"
                aria-valuenow="0"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="`width: ${getProgressPercentage}%;`">
              </div>
            </div>
          </div>
        </div>
        <div class="app-project-sources-splash__section-column is--img">
          <img class="app-project-sources-splash__img" src="/img/undraw_data-analysis.svg" />
        </div>
      </div>
    </div>

    <div class="app-project-sources-splash__section is--no-golden-source" v-else-if="hasGoldenSourceError">
      <div class="app-project-sources-splash__section-content">
        <div class="app-project-sources-splash__section-column is--text">
          <h4 class="app-project-sources-splash__section-title page-main__title">Unexpected error</h4>
          <div class="app-project-sources-splash__section-instructions">
            <p>Your project's Golden Source analysis has produced an error.</p>
            <p class="app-project-sources-splash__section-error"><b>Error message:</b> {{ getGoldenSourceError }}</p>
            <p>Before you re-submit materials for analysis, check for these common errors:</p>
            <ul>
              <li>Documents do not meet the 40-character count minimum</li>
              <li>MP4s or MP3s do not contain audio</li>
              <li>Content is not in the English language</li>
              <li>PDFs are image-based and do not feature selectable text</li>
              <li>Images do not meet the image extraction minimum width/height (180px)</li>
            </ul>
            <p>When you confirm your materials are ready for submission, please try again.</p>
          </div>
          <a class="element-button--primary element-button" :href="`/projects/${project.id}/sources/${project.project_source?.id || ''}`">Try again</a>
        </div>
      </div>
    </div>

    <div class="app-project-sources-splash__section is--no-golden-source" v-else-if="!hasGoldenSource">
      <div class="app-project-sources-splash__section-content">
        <div class="app-project-sources-splash__section-column is--text">
          <h4 class="app-project-sources-splash__section-title page-main__section-title">Set up your project</h4>
          <p class="app-project-sources-splash__section-instructions">
            Before you can publish courses, you must first set up a Golden Source. This is a collection of all documents you plan to reference in this project (think: BPDs, SMR interview notes, etc.). Once uploaded, AI will analyze the files to create a high-quality vocabulary index that organizes the content into topics and groupings of topics, called domains. You'll generate courses by selecting topics and domains that align to your desired curriculum.
Take a moment to gather all relevant documentation now. You'll have the opportunity to add documents later, if needed.
            <br /><br />
            To start, take a moment to gather all relevant documentation now.
          </p>
          <a class="element-button--primary element-button" :href="`/projects/${project.id}/sources/${project.project_source?.id || ''}`">Create Golden Source</a>
        </div>
        <div class="app-project-sources-splash__section-column is--img">
          <img class="app-project-sources-splash__img" src="/img/undraw_create.svg" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import _ from 'lodash'

export default {
  components: { },
  props: {
    project: {
      type: Object
    },
    projectSource: {
      type: Object,
      default: null
    },
    isAnalyzing: {
      type: Boolean,
      default: false
    },
    hasGoldenSource: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      
    }
  },
  computed: {
    getProgressPercentage() {
      const progress = this.projectSource && this.projectSource.settings ? this.projectSource.settings['progress'] : 0
      return Math.round(progress * 100) || 0
    },
    hasGoldenSourceError() {
      return (this.projectSource && this.projectSource.errors)
    },
    getGoldenSourceError() {
      return (this.projectSource && this.projectSource.errors) ? this.projectSource.errors : null
    },
  },
  methods: {

  },
  created() {

  }
}
</script>
